import { Invoice } from "../../../../models";
import { containsDuplicates } from "../../../../utils";

export const hasDuplicateInvoiceLineItems = (invoice: Invoice): boolean => {
  const filtered = invoice?.invoiceLineItems?.filter(
    (x) => x.inventoryItem?.skipDuplicationCheck === false
  );
  return !!containsDuplicates(filtered, "inventoryItemId");
};
